import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';

import TransparentButton from '../TransparentButton';
import MobileMenu from '../MobileMenu';

import { detectSwipe } from '../../../services/ui/swipeDetector';

import styles from './styles.scss';

export default class BasicHeader extends React.Component {

    constructor() {
        super();

        this.state = {
            isMenuOpen: false
        }
    }

    _toggleMenu() {

        if (this.state.isMenuOpen) {
            document.body.classList.remove('no-scroll');
        } else {
            document.body.classList.add('no-scroll');
        }

        this.setState({ isMenuOpen: !this.state.isMenuOpen });
    }

    _attachSwipeDetector(elem) {

        if (this.swipeDetectorInitialised)
            return;

        detectSwipe(ReactDOM.findDOMNode(elem), (direction) => {
            if (direction === 'right') {
                this._toggleMenu();
            }
        });

        this.swipeDetectorInitialised = true;
    }

    render() {
        return (
            <header id="page-header" className={styles['header']} role="banner">
                <Link className={styles['logo-link']} to="/">
                    <img
                        className={styles['logo']}
                        src="/images/logos/rhe_logo_light.png"
                        alt="Go to the My Account homepage"
                    />
                </Link>

                <TransparentButton
                    aria-expanded={this.state.isMenuOpen}
                    aria-controls="mobile-menu"
                    onClick={this._toggleMenu.bind(this)}
                    className={styles['menu-icon-button']}
                >
                    <i className={`fa fa-bars ${styles['menu-icon']}`} aria-hidden="true" />
                    <span className="sr-only">Toggle navigation menu</span>
                </TransparentButton>

                <MobileMenu
                    ref={this._attachSwipeDetector.bind(this)}
                    onMenuItemClick={this._toggleMenu.bind(this)}
                    isOpen={this.state.isMenuOpen}
                />
            </header>
        );
    }
}
